import firebase from 'firebase/app'

// Vuex
import { MutationTree } from 'vuex'
import { MatchState } from './state'

export default <MutationTree<MatchState>>{
  /**
   * Toggle operations-lock
   * @param state
   */
  toggleControlsLock(state) {
    state.controlsLocked = !state.controlsLocked
  },

  /**
   * Refresh timestamp to keep in sync with realtime
   * @param state
   */
  refreshRealtimeTimestamp(state) {
    state.realtime.timestamp = firebase.firestore.Timestamp.now()
  },

  setRealtimeInterval(state, interval) {
    state.realtime.interval = interval
  },

  /**
   * Stop realtime interval
   *
   * @param state
   * @returns
   */
  stopRealtimeInterval(state) {
    if (!state.realtime.interval) {
      return
    }

    clearInterval(state.realtime.interval)
    state.realtime.interval = null
  },
}
